import { render, staticRenderFns } from "./full.vue?vue&type=template&id=ecc5143a&"
import script from "./full.vue?vue&type=script&lang=js&"
export * from "./full.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports